import { Spacing, Subhead } from '@vkontakte/vkui';
import React, { memo, useCallback } from 'react';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import type { MobileBuyClickType } from 'reactApp/sections/MobileSubscriptionsPage/TariffCard/TariffCard.types';
import type { Product } from 'reactApp/types/Billing';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { useYearSaving } from 'reactApp/ui/TariffSectionNew/hooks/useYearSaving';
import { getPeriodName } from 'reactApp/utils/Period';
import { formatPrice, getMonthProductPrice } from 'reactApp/utils/priceHelpers';

import styles from './MultiTariffsListMobile.css';

interface Props {
    monthProduct: Product;
    yearProduct: Product;
    onBuy: MobileBuyClickType;
}

export const BuyButtons = memo<Props>(({ yearProduct, monthProduct, onBuy }) => {
    const isYearTrial = yearProduct.hasTrial && Boolean(yearProduct?.trialPeriod);

    const [, yearSavingDiscount] = useYearSaving({
        monthProduct,
        yearProduct,
    });

    const onButtonClick = useCallback(
        (isYear) => {
            onBuy({
                selectedProduct: isYear ? yearProduct : monthProduct,
                yearProduct: isYear ? undefined : yearProduct,
                yearSavingDiscount: isYear ? undefined : yearSavingDiscount,
                paySource: getPaySource('tariff_card'),
            });
        },
        [yearProduct, monthProduct, yearSavingDiscount, onBuy]
    );

    return (
        <div className={styles.buttonBlock}>
            <Button primary theme="vk" sizeMode={ButtonSizeMode.extraBig} onClick={() => onButtonClick(true)}>
                <div>
                    <div>{isYearTrial ? 'Бесплатно' : `${formatPrice(getMonthProductPrice(yearProduct))} ₽ в месяц`}</div>
                    <Subhead>{isYearTrial ? `на ${getPeriodName(yearProduct.trialPeriod as string)}` : `при покупке на год`}</Subhead>
                </div>
            </Button>
            <Spacing size={12} />
            <Button secondary theme="vk" sizeMode={ButtonSizeMode.extraBig} onClick={() => onButtonClick(false)}>
                {formatPrice(getMonthProductPrice(monthProduct))} ₽ в месяц
            </Button>
            {yearSavingDiscount && !isYearTrial && <div className={styles.saving}>-{yearSavingDiscount}%</div>}
        </div>
    );
});

BuyButtons.displayName = 'BuyButtons';
